/** All plugins exist on a CDN
 *
 * Each should be prefixed with the CDN root, but take note:
 * await import(variableContainingFullPath) does not work!
 * await import(root + slug) does not work!
 * await import('https://s3.com/hardcoded/root/' + slug) WORKS!
 * await import(`${var}`) WORKS!
 * await import(`${root}${slug}`) WORKS!
 */

import RasaPlugin from './plugins/rasaPlugin'
import coverpagePlugin from './plugins/coverpagePlugin'
import AscPlugin from "./plugins/ascPlugin"

import { widgetPluginsId } from './utils'

/** All plugin names and their CDN slugs (or directly referenced PluginInterface subclasses if testing) */
const pluginUrlMap = {
    rasa_1: RasaPlugin,
    cover_page_plugin: coverpagePlugin,
    asc_plugin: AscPlugin,
}

export function PluginFactory() {
    this.create = async data => {
        if (data.plugin in pluginUrlMap) {
            let pluginSlug = pluginUrlMap[data.plugin]
            return new pluginSlug(data)
        } else {
            let message = `Plugin ${data.plugin} does not refer to an existing plugin. Please check the data-plugin name(s) inside ${widgetPluginsId}`
            throw Error(message)
        }
    }
}
